import { addDays, setHours, setMinutes } from 'date-fns';
import { create } from 'zustand';

import type { CancellationPolicy, Discount, Insurance } from '@/api';
import type { Car } from '@/api/cars/types';
// import { persist } from 'zustand/middleware';
import type { Address } from '@/api/subscriptions/types';

interface BookCarState {
  deliveryModeEnabled: boolean;
  address: Address | null;
  startDatetime: Date | null;
  endDatetime: Date | null;
  deliveryDeliverToAddress: Address | null;
  deliveryReturnAddress: Address | null;
  locationId: number | undefined;
  car: Car | null;
  insurance: Insurance | null;
  cancellationPolicy: CancellationPolicy | null;
  discount: Discount | null;
  setDeliveryModeEnabled: (deliveryModeEnabled: boolean) => void;
  setAddress: (address: any) => void;
  setStartDatetime: (startDatetime: Date) => void;
  setEndDatetime: (endDatetime: Date) => void;
  setDeliveryDeliverToAddress: (deliveryDeliverToAddress: any) => void;
  setDeliveryReturnToAddress: (deliveryReturnAddress: any) => void;
  setLocationId: (locationId: number) => void;
  setCar: (car: Car) => void;
  setInsurance: (insurance: Insurance) => void;
  setCancellationPolicy: (cancellationPolicy: CancellationPolicy) => void;
  setDiscount: (discount: Discount) => void;
  reset: () => void;
}

const startDatetime = setMinutes(setHours(addDays(new Date(), 1), 11), 0);
const endDatetime = setMinutes(setHours(addDays(startDatetime, 3), 11), 0);

const useBookCarStore = create<BookCarState>((set) => ({
  deliveryModeEnabled: false,
  address: null,
  startDatetime: startDatetime,
  endDatetime: endDatetime,
  deliveryDeliverToAddress: null,
  deliveryReturnAddress: null,
  locationId: undefined,
  car: null,
  insurance: null,
  cancellationPolicy: null,
  discount: null,
  setDeliveryModeEnabled: (deliveryModeEnabled: boolean) => {
    set((state) => ({
      ...state,
      deliveryModeEnabled,
    }));
  },
  setAddress: (address: any) => {
    set((state) => ({
      ...state,
      address,
    }));
  },
  setStartDatetime: (startDatetime: Date) => {
    set((state) => ({
      ...state,
      startDatetime,
    }));
  },
  setEndDatetime: (endDatetime: Date) => {
    set((state) => ({
      ...state,
      endDatetime,
    }));
  },
  setDeliveryDeliverToAddress: (deliveryDeliverToAddress: any) => {
    set((state) => ({
      ...state,
      deliveryDeliverToAddress,
    }));
  },
  setDeliveryReturnToAddress: (deliveryReturnAddress: any) => {
    set((state) => ({
      ...state,
      deliveryReturnAddress,
    }));
  },
  setLocationId: (locationId: number | undefined) => {
    set((state) => ({
      ...state,
      locationId,
    }));
  },
  setCar: (car: Car) => {
    set((state) => ({
      ...state,
      car,
    }));
  },
  setInsurance: (insurance: Insurance) => {
    set((state) => ({
      ...state,
      insurance,
    }));
  },
  setCancellationPolicy: (cancellationPolicy: CancellationPolicy) => {
    set((state) => ({
      ...state,
      cancellationPolicy,
    }));
  },
  setDiscount: (discount: Discount) => {
    set((state) => ({
      ...state,
      discount,
    }));
  },
  reset: () => {
    set((state) => ({
      deliveryModeEnabled: false,
      address: null,
      startDatetime: startDatetime,
      endDatetime: endDatetime,
      deliveryDeliverToAddress: null,
      deliveryReturnAddress: null,
      locationId: undefined,
      car: null,
      insurance: null,
      discount: null,
    }));
  },
}));

export default useBookCarStore;

// export const useSearchStore = createSelectors(_useSearchStore);

// export const setAddress = (address: string) =>
//   _useSearchStore.getState().setAddress(address);
